export default __webpack_public_path__ + "static/media/class_x_medical.803de4db.png";